import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import styled, { css } from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { NavigationButton } from "@sprout/list-navigation";
const TopicPageViewMoreButton = styled(Button)`
  flex-direction: column;
  flex: none;

  border-radius: 12px;
  border: 1px solid ${themeGet("colors.black.12")};

  padding: 8px 12px;

  :disabled {
    opacity: 0.6;
  }

  ${({ isActive  })=>isActive && css`
      background: rgba(25, 118, 210, 0.04);
    `};
`;
const TopicPageViewMoreLine = styled(Box)`
  flex: 1;

  margin: auto;
  border-top: 1px dashed ${themeGet("colors.grey.600")};
`;
const TopicPageViewMore = (props)=>{
    const { count , loadMore , loading  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        justifyContent: "center",
        my: 5,
        children: [
            /*#__PURE__*/ _jsx(TopicPageViewMoreLine, {}),
            /*#__PURE__*/ _jsx(NavigationButton, {
                uuid: "d82430f8-a239-4f5f-b733-375cd1376436",
                onOpen: loadMore,
                children: ({ isActive  })=>/*#__PURE__*/ _jsxs(TopicPageViewMoreButton, {
                        onClick: loadMore,
                        disabled: loading,
                        isActive: isActive,
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                fontSize: 1,
                                as: "span",
                                color: "black.60",
                                children: [
                                    count,
                                    " hidden items"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "15px",
                                as: "span",
                                color: "blue.500",
                                fontWeight: "medium",
                                children: "See more"
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ _jsx(TopicPageViewMoreLine, {})
        ]
    });
};
export default TopicPageViewMore;
